var React = require('react');

function Se (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("clipPath",{"id":"a"},React.createElement("path",{"fillOpacity":".7","d":"M-53.4 0h682.6v512H-53.4z"}))),React.createElement("g",{"clipPath":"url(#a)","transform":"translate(50) scale(.9375)","key":1},React.createElement("g",{"fillRule":"evenodd","strokeWidth":"1pt"},[React.createElement("path",{"fill":"#006aa7","d":"M-121.1.3h256v204.8h-256zm0 306.9h256V512h-256z","key":0}),React.createElement("path",{"fill":"#fecc00","d":"M-121.1 205h256v102.4h-256z","key":1}),React.createElement("path",{"fill":"#fecc00","d":"M133.8 0h102.4v512H133.8z","key":2}),React.createElement("path",{"fill":"#fecc00","d":"M233 205h460.8v102.4H233z","key":3}),React.createElement("path",{"fill":"#006aa7","d":"M236.2 307.2H697V512H236.2zm0-306.9H697v204.8H236.2z","key":4})]))]);
}

Se.defaultProps = {"viewBox":"0 0 640 480"};

module.exports = Se;

Se.default = Se;
